<template>
  <div class="Wdgt-Signal-Content">
    <!--Если пользователь не имеет доступа к платному контенту-->
    <template v-if="get_isLockPaidContent && !get_isUserLoading">
       <div class="Wdgt-Signal-Content__no-paid-box" >
        <CapitalInfo />
      </div>
    </template>
    <!--Отобразить, если пользователь имеет доступ к платному контенту-->
    <template v-else>
      <div class="Wdgt-Signal-Content__box" v-if="get_signal">
        <!--Шапка-->
        <header class="Wdgt-Signal-Content__hdr">
          <div class="Wdgt-Signal-Content__hdr-side">
            <BlockAuthorTimeCommentFire
              class="Wdgt-Signal-Content__stats"
              :date="get_time"
              :author="get_signal.author"
              :link="get_signal.link"
              :commentsCount="get_signal.comments_count"
              :initCommentsCount="get_signal.init_comments_count"
              @callComments="toCallComments"
            />
          </div>
          <div class="Wdgt-Signal-Content__hdr-side Wdgt-Signal-Content__hdr-side--end">
            <div class="Wdgt-Signal-Content__menu" ref="menuRef" v-if="get_isModerator">
              <ButtonPoints class="Wdgt-Signal-Content__btn" @click="toToggleMenu"/>
              <transition name="Anim__fadeUp">
                <DropMenuSignal class="Wdgt-Signal-Content__menu-box" :signalId="ID" v-if="isOpen" />
              </transition>
            </div>
          </div>
        </header>
        <!--Контент-->
        <div class="Wdgt-Signal-Content__wrapper">
          <!--Заголовок и текст-->
          <div class="Wdgt-Signal-Content__content-hdr">
            <h2 class="Wdgt-Signal-Content__ttl">{{ get_signal.title }}</h2>
            <p class="Wdgt-Signal-Content__description" v-html="get_formattedContent"></p>
          </div>
          <div class="Wdgt-Signal-Content__content-ftr-box">
            <!--Изображения-->
            <div class="Wdgt-Signal-Content__images">
              <img class="Wdgt-Signal-Content__cover" v-for="(img, index) in get_signal.images_list" :src="img" @click="openSlider(index)" />
            </div>

          </div>
          <!--Статистика-->
          <div class="Wdgt-Signal-Content__params">
            <AddSignalToFavourites class="Wdgt-Signal-Content__bookmark" :signal="get_signal" />
            <a class="Wdgt-Signal-Content__token Coin-Info-Tooltip" :href="get_signal.coin.dropstab_url" target="_blank" :data-coin="get_signal.coin.slug">
              <AvatarImage :size="20" :src="get_signal.coin.image" /> {{ get_signal.coin.symbol }}
            </a>
            <div class="Wdgt-Signal-Content__signal-box">
              <div class="Wdgt-Signal-Content__start-stats">
                <span class="Wdgt-Signal-Content__ttl-value">{{ `${formatDayAndMonth(get_signal.publication_date || get_signal.created_at)}` }}</span>
                <span class="Wdgt-Signal-Content__value">{{ `$${formatPriceFull(get_signal.start_price_usd)}` }}</span>
              </div>
              <p class="Wdgt-Signal-Content__change-value"
                :class="get_signal.change_all_time_percent < 0 ? 'Wdgt-Signal-Content__change-value--red' : 'Wdgt-Signal-Content__change-value--green'"
              >
                <ArrowChangeValue />
                {{ get_signal.change_all_time_percent }}%
              </p>
              <div class="Wdgt-Signal-Content__now-stats">
                <span class="Wdgt-Signal-Content__ttl-value">Сейчас</span>
                <span class="Wdgt-Signal-Content__value">{{ `$${formatPriceFull(get_signal.price_usd)}` }}</span>
              </div>
            </div>
            <div class="Wdgt-Signal-Content__high-low">
              <p class="Wdgt-Signal-Content__high-price">
                {{ get_signal.change_ath }}% <span class="Wdgt-Signal-Content__price-ttl">High</span>
              </p>
              <p class="Wdgt-Signal-Content__low-price">
                {{ get_signal.change_atl }}% <span class="Wdgt-Signal-Content__price-ttl">Low</span>
              </p>
            </div>
          </div>
        </div>
        <!--Реакции-->
        <div class="Wdgt-Signal-Content__reactions">
          <ContentReactions :signalId="get_signal.id"/>
        </div>
        <!--Комментарии-->
        <ContentComments class="Wdgt-Signal-Content__content-comments" :commentsPlace="props.commentsPlace" :signalId="ID" ref="comments"/>
      </div>
    </template>
  </div>
</template>

<script setup>
  import { Props } from './scripts/props.js';
  import { useStore } from 'vuex';
  import { computed, ref, onMounted, onBeforeUnmount } from 'vue';
  import { formatDayAndMonth } from '@shared/utils/time/formated';
  import { sliderImagesGroupDisplay } from '@/Groups/Slider/public/utils/callSlider.js';
  import { formatPriceFull } from '@shared/utils/price/formatedPrice.js';
  //---------------------------------
  import BlockAuthorTimeCommentFire from '@ui/Blocks/BlockAuthorTimeCommentFire/BlockAuthorTimeCommentFire.vue';
  import ContentReactions from '@widgets/ContentWidget/general/Reactions/ContentReactions.vue';
  import ContentComments from '@widgets/ContentWidget/general/Comments/ContentComments.vue';
  import DropMenuSignal from '@features/DropMenu/modules/DropMenuSignal/DropMenuSignal.vue';
  import ButtonPoints from '@ui/Buttons/ButtonPoints/ButtonPoints.vue';
  import AddSignalToFavourites from '@features/Signals/AddSignalToFavourites/AddSignalToFavourites.vue';
  import CapitalInfo from '@widgets/ContentWidget/general/CapitalInfo/CapitalInfo.vue';
  import AvatarImage from '@shared/UI/Images/AvatarImage/AvatarImage.vue';
  import ArrowChangeValue from '@shared/UI/SVG/arrows/ArrowChangeValues.vue';
  //---------------------------------
  const store = useStore();
  const props = defineProps(Props());
  //---------------------------------
  const ID = window.location.pathname.match(/\/signal\/(\d+)/)[1];
  //---------------------------------
  const isOpen = ref(false);
  const menuRef = ref(null);
  const comments = ref(null);
  const observer = ref(null);
  //---------------------------------
  onMounted(() => {
    document.addEventListener('click', handleClickOutside);
    observeCommentsVisibility();
  });
  onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
  });
  //---------------------------------
  //Является ли пользователь модератором?
  const get_isModerator = computed(() => store.getters['UserSystem/hasModeratorPrivileges']);
  //Получить из хранилища сигнал
  const get_signal = computed(() => store.state.OldSignals.data[ID]);
  //Получить время
  const get_time = computed(() => get_signal.value.publication_date || get_signal.value.created_at);
  //Пользователь не имеет доступа к закрытому контенту (нет платной подписки)
  const get_isLockPaidContent = computed(() => !store.getters['UserSystem/hasPaidAccess']);
  //Идет ли звгрузка данных пользователя
  const get_isUserLoading = computed(() => !store.state.UserSystem.isReady && store.state.UserSystem.user.isAuthenticated);
  //Форматирование текста
  const get_formattedContent = computed(() => {
    if (!get_signal.value.content) return '';
    const urlRegex = /(https?:\/\/|ftp:\/\/|www\.)[^\s/$.?#].[^\s]*/gi;
    return get_signal.value.content.replace(urlRegex, (url) => {
      const fullUrl = url.startsWith('www.') ? `http://${url}` : url;
      return `<a href="${fullUrl}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  })
  //---------------------------------
  //Проскролить до секции с комментариями
  const toCallComments = () => {
    const scrollItem = comments.value?.$refs.contentComments;
    const scrollModal = document.querySelector('[data-content-scroll-wrapper]');
    const pageScroll = document.querySelector('[page-article]');
    if (!scrollItem) return;
    const rect = scrollItem.getBoundingClientRect();
    // Скролл в модалке или скролл на странице
    if (scrollModal) {
      const scrollPosition = scrollModal.scrollTop + rect.top;
      scrollModal.scrollTo({
        top: scrollPosition - 70,
        behavior: 'auto',
      });
    } else if (pageScroll) {
      const scrollPosition = window.scrollY + rect.top;
      window.scrollTo({
        top: scrollPosition - 70,
        behavior: 'auto',
      });
    }
  };
  //Отобразить/скрыть меню
  const toToggleMenu = () => isOpen.value = !isOpen.value;
  //Закрыть меню, если клик вне области меню
  const handleClickOutside = (event) => {
    if(menuRef.value && !menuRef.value.contains(event.target)) {
      isOpen.value = false;
    }
  };
  //Открыть слайдер с нужным индексом
  const openSlider = (index) => {
    sliderImagesGroupDisplay(prepareData(), index);
  }
  //Подготовить массив слайдов
  const prepareData = () => {
    /* const slides = [];
    get_signal.value.images_list.forEach(img => {
      slides.push({ src: img, text: null })
    });
    return slides; */
    const slides = [];
    get_signal.value.images_list.forEach(img => {
      slides.push({ url: img, caption: null })
    });
    return slides;
  };
  //Создаем обесрвер чтобы определить, что comments block попал в область видимости
  const observeCommentsVisibility = () => {
    const target = comments.value?.$el;
    if (!target) return;
    observer.value = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        toUpdateNewCommentsCounter();
      },
      {root: null, rootMargin: '0px', threshold: 0.1,}
    );
    observer.value.observe(target);
  };
  //Обновить счетчик новых комментариев
  const toUpdateNewCommentsCounter = () => {
    store.dispatch(`OldSignals/updateCommentsCounter`, { id: ID, isAlignValues: true });
  }
</script>

<style lang="scss">
  @import "./styles/_styles";
</style>
